/* ============================================================
   Healthy Sips theme - GLOBAL CHROME JS
   loader, nav scroll, scroll reveal, pause-when-hidden,
   mobile menu, theme toggle, footer dome, cart, newsletter
   ============================================================ */

/* --- loader + nav scroll + scroll reveal --- */
(function(){
/* Loader */
        (function(){var l=document.getElementById('loader');if(!l)return;if(sessionStorage.getItem('hsSeen')){l.style.transition='none';l.classList.add('hidden');return;}sessionStorage.setItem('hsSeen','1');setTimeout(function(){l.classList.add('hidden');},450);})();


        /* Nav scroll */
        window.addEventListener('scroll', function() {
            document.getElementById('main-nav').classList.toggle('scrolled', window.scrollY > 80);
        }, { passive: true });

        /* Scroll reveal — robust against the theme editor re-rendering / adding sections.
           In design mode (or without IntersectionObserver) reveal instantly so an edited or
           newly added section never stays at opacity:0 (i.e. never looks "blank"). */
        var REVEAL_SEL = '.reveal, .reveal-left, .reveal-right, .reveal-scale';
        var inDesignMode = !!(window.Shopify && window.Shopify.designMode);
        var supportsIO = 'IntersectionObserver' in window;
        var ro = supportsIO ? new IntersectionObserver(function(entries) {
            entries.forEach(function(e) { if (e.isIntersecting) e.target.classList.add('visible'); });
        }, { threshold: 0.12, rootMargin: '0px 0px -30px 0px' }) : null;
        function showAll(root) {
            var scope = root && root.querySelectorAll ? root : document;
            /* add every reveal "shown" class so both the global (.visible) and the section-local
               (.in-view) reveal mechanisms un-hide; harmless where a class is unused */
            scope.querySelectorAll(REVEAL_SEL).forEach(function(el) {
                el.classList.add('visible');
                el.classList.add('in-view');
            });
        }
        function observeIn(root) {
            var scope = root && root.querySelectorAll ? root : document;
            scope.querySelectorAll(REVEAL_SEL).forEach(function(el) { ro.observe(el); });
        }
        /* Initial: in the theme editor (or without IntersectionObserver) reveal everything instantly so
           nothing ever sits at opacity:0; on the live storefront keep the scroll-reveal effect. */
        if (inDesignMode || !supportsIO) { showAll(document); } else { observeIn(document); }
        /* Theme editor lifecycle: a re-rendered, selected, or newly inserted section/block must show its
           content immediately (these events only fire inside the editor), so reveal it directly. */
        ['shopify:section:load', 'shopify:section:select', 'shopify:block:select', 'shopify:section:reorder'].forEach(function(ev) {
            document.addEventListener(ev, function(e) { showAll(e.target); });
        });
        window.HSrevealIn = showAll;
})();

/* --- pause animations when off-screen --- */
(function(){
  function pauseWhenHidden(el){
    if(!el||!('IntersectionObserver' in window))return;
    el.style.animationPlayState='paused';
    new IntersectionObserver(function(es){es.forEach(function(e){el.style.animationPlayState=e.isIntersecting?'running':'paused';});},{rootMargin:'80px'}).observe(el);
  }
  pauseWhenHidden(document.querySelector('.marquee-track'));
  pauseWhenHidden(document.getElementById('ugc-track'));
})();

/* --- iOS-safe body scroll lock (shared by mobile menu + cart drawer) ---
   overflow:hidden alone does NOT stop touch scroll on iOS Safari, so we pin the
   body with position:fixed at its current offset and restore on unlock. Ref-counted
   so an overlapping open/close pair never unlocks early. */
(function(){
  var y=0, n=0;
  window.HSlockScroll=function(){
    if(n++>0)return;
    y=window.scrollY||window.pageYOffset||0;
    document.body.style.top=(-y)+'px';
    document.body.classList.add('scroll-locked');
  };
  window.HSunlockScroll=function(){
    if(n===0)return;
    if(--n>0)return;
    document.body.classList.remove('scroll-locked');
    document.body.style.top='';
    window.scrollTo(0,y);
  };
})();

/* --- mobile menu --- */
(function(){
  var burger=document.querySelector('.nav-burger');
  var menu=document.getElementById('mobile-menu');
  if(!burger||!menu)return;
  var closeBtn=menu.querySelector('.mm-close');
  function openM(){menu.classList.add('open');document.body.classList.add('menu-open');if(window.HSlockScroll)window.HSlockScroll();burger.setAttribute('aria-expanded','true');if(closeBtn)closeBtn.focus();}
  function closeM(){if(!menu.classList.contains('open'))return;menu.classList.remove('open');document.body.classList.remove('menu-open');if(window.HSunlockScroll)window.HSunlockScroll();burger.setAttribute('aria-expanded','false');burger.focus();}
  burger.addEventListener('click',function(){menu.classList.contains('open')?closeM():openM();});
  if(closeBtn)closeBtn.addEventListener('click',closeM);
  // Shop accordion: toggle on a SINGLE tap (intercept so the native <details> toggle can't double-fire on touch)
  var mmShopSummary=menu.querySelector('.mm-shop-summary');
  if(mmShopSummary){ mmShopSummary.addEventListener('click',function(e){ e.preventDefault(); var d=mmShopSummary.closest('details'); if(d) d.open=!d.open; }); }
  Array.prototype.forEach.call(menu.querySelectorAll('a'),function(a){a.addEventListener('click',closeM);});
  document.addEventListener('keydown',function(e){if(e.key==='Escape'||e.keyCode===27)closeM();});
})();

/* --- desktop Shop mega-menu (portaled outside #main-nav; hover/focus intent with a small close delay) --- */
(function(){
  var trigger=document.querySelector('.nav-shop');
  var mega=document.getElementById('shop-mega');
  var nav=document.getElementById('main-nav');
  if(!trigger||!mega||!nav) return;
  var hideT;
  function place(){ mega.style.top=(nav.getBoundingClientRect().bottom+10)+'px'; }
  function open(){ clearTimeout(hideT); place(); mega.classList.add('open'); trigger.classList.add('nav-shop--open'); }
  function close(){ mega.classList.remove('open'); trigger.classList.remove('nav-shop--open'); }
  function later(){ clearTimeout(hideT); hideT=setTimeout(close,140); }
  trigger.addEventListener('mouseenter',open);
  trigger.addEventListener('mouseleave',later);
  trigger.addEventListener('focusin',open);
  mega.addEventListener('mouseenter',function(){clearTimeout(hideT);});
  mega.addEventListener('mouseleave',later);
  document.addEventListener('focusin',function(e){ if(!trigger.contains(e.target)&&!mega.contains(e.target)) close(); });
  document.addEventListener('keydown',function(e){ if(e.key==='Escape') close(); });
  window.addEventListener('scroll',function(){ if(mega.classList.contains('open')) place(); },{passive:true});
})();

/* --- theme toggle (light/dark) --- */
(function(){
  var btn=document.getElementById('theme-toggle');
  var mbtn=document.getElementById('theme-toggle-m');
  function cur(){return document.documentElement.getAttribute('data-theme')==='dark'?'dark':'light';}
  function setMeta(t){var m=document.querySelector('meta[name="theme-color"]');if(m)m.setAttribute('content',t==='dark'?'#14110F':'#FBF8F4');}
  function setLabel(b,t){if(b)b.setAttribute('aria-label',t==='dark'?'Switch to light theme':'Switch to dark theme');}
  function apply(t){document.documentElement.setAttribute('data-theme',t);try{localStorage.setItem('hs-theme',t);}catch(e){}setMeta(t);setLabel(btn,t);setLabel(mbtn,t);}
  function toggle(){apply(cur()==='dark'?'light':'dark');}
  if(btn)btn.addEventListener('click',toggle);
  if(mbtn)mbtn.addEventListener('click',toggle);
  var t0=cur();setMeta(t0);setLabel(btn,t0);setLabel(mbtn,t0);
})();

/* --- footer colour dome cycle --- */
(function(){var f=document.querySelector('footer');var b=document.querySelector('.footer-blob-semi');if(!f||!b)return;if(!('IntersectionObserver' in window))return;b.style.animationPlayState='paused';new IntersectionObserver(function(es){es.forEach(function(e){b.style.animationPlayState=e.isIntersecting?'running':'paused';});},{rootMargin:'120px'}).observe(f);})();

/* --- Shopify AJAX cart --- */
(function(){
  var SHOP = window.HSshop || {currency:'USD', freeShip:50, routes:{cartAdd:'/cart/add.js', cartChange:'/cart/change.js', cart:'/cart.js'}};
  var drawer=document.getElementById('cart-drawer'), overlay=document.getElementById('cart-overlay'),
      itemsEl=document.getElementById('cart-items'), emptyEl=document.getElementById('cart-empty'),
      totalEl=document.getElementById('cart-total'), subEl=document.getElementById('cart-subtotal'),
      grandEl=document.getElementById('cart-grand-total'), toggle=document.getElementById('cart-toggle'),
      closeBtn=document.getElementById('cart-close'), toast=document.getElementById('toast'),
      toastText=document.getElementById('toast-text'), fillEl=document.getElementById('csp-fill'),
      shipProg=document.getElementById('cart-ship-progress'), countEls=document.querySelectorAll('#cart-count, .cart-count');
  var fmt; try{ fmt=new Intl.NumberFormat(undefined,{style:'currency',currency:SHOP.currency||'USD'}); }catch(e){ fmt=null; }
  function money(c){ var v=(c||0)/100; return fmt?fmt.format(v):('$'+v.toFixed(2)); }
  function el(tag,cls,txt){ var e=document.createElement(tag); if(cls)e.className=cls; if(txt!=null)e.textContent=txt; return e; }
  function openCart(){ if(drawer)drawer.classList.add('open'); if(overlay)overlay.classList.add('open'); document.body.classList.add('cart-open'); if(window.HSlockScroll)window.HSlockScroll(); if(toggle)toggle.setAttribute('aria-expanded','true'); }
  function closeCart(){ if(drawer)drawer.classList.remove('open'); if(overlay)overlay.classList.remove('open'); document.body.classList.remove('cart-open'); if(window.HSunlockScroll)window.HSunlockScroll(); if(toggle)toggle.setAttribute('aria-expanded','false'); }
  function showToast(m,isError){ if(toast&&toastText){ toastText.textContent=m; toast.classList.toggle('toast--error',!!isError); toast.classList.add('show'); setTimeout(function(){toast.classList.remove('show');},2200); } }
  function setCount(n){ Array.prototype.forEach.call(countEls,function(e){ e.textContent=n; }); }
  function getPostal(){ try{ return (localStorage.getItem('hs-postal')||'').toUpperCase(); }catch(e){ return ''; } }
  function postalThreshold(){ var p=getPostal(); var mb=p.charAt(0)==='R'; return (mb?(SHOP.freeShipMb||100):(SHOP.freeShip||50))*100; }
  var postalForm=document.getElementById('csp-postal-form'), postalInput=document.getElementById('csp-postal-input'),
      postalSaved=document.getElementById('csp-postal-saved'), postalCodeEl=document.getElementById('csp-postal-code'),
      postalChange=document.getElementById('csp-postal-change');
  function updatePostalUI(){
    if(!postalForm||!postalSaved) return;
    var p=getPostal();
    if(p){ postalForm.style.display='none'; postalSaved.style.display='';
      if(postalCodeEl) postalCodeEl.textContent=p; }
    else { postalForm.style.display=''; postalSaved.style.display='none'; }
  }
  if(postalForm) postalForm.addEventListener('submit',function(e){
    e.preventDefault();
    var v=((postalInput&&postalInput.value)||'').toUpperCase().replace(/\s+/g,'');
    if(!/^[A-Z]\d[A-Z]\d[A-Z]\d$/.test(v)){ showToast('Please enter a valid postal code', true); return; }
    v=v.slice(0,3)+' '+v.slice(3);
    try{ localStorage.setItem('hs-postal',v); }catch(err){}
    updatePostalUI(); getCart();
  });
  if(postalChange) postalChange.addEventListener('click',function(){
    if(postalForm){ postalForm.style.display=''; }
    if(postalInput){ postalInput.value=getPostal(); }
    if(postalSaved) postalSaved.style.display='none';
    if(postalInput) postalInput.focus();
  });
  updatePostalUI();
  function buildLine(it,i){
    var line=el('div','cart-line'); line.setAttribute('data-line', i+1);
    if(it.image){
      var img=el('img','cart-line__img'); img.src=it.image.replace(/(\.[a-zA-Z]+)(\?|$)/,'_120x$1$2'); img.alt=''; img.width=56; img.height=56; img.loading='lazy'; line.appendChild(img);
    } else {
      // No product image (e.g. bundles): keep a same-size placeholder so title/qty/price stay column-aligned.
      var ph=el('div','cart-line__img cart-line__img--placeholder');
      ph.setAttribute('aria-hidden','true');
      var glyph=(it.product_title||'').replace(/[^A-Za-z0-9]/g,'').charAt(0).toUpperCase();
      if(glyph) ph.appendChild(el('span','cart-line__img-glyph',glyph));
      line.appendChild(ph);
    }
    var info=el('div','cart-line__info');
    info.appendChild(el('div','cart-item-name', it.product_title));
    if(it.variant_title && it.variant_title!=='Default Title') info.appendChild(el('div','cart-line__variant', it.variant_title));
    var qty=el('div','cart-item-qty');
    var dec=el('button','cart-q','−'); dec.type='button'; dec.setAttribute('data-line',i+1); dec.setAttribute('data-q',it.quantity-1); dec.setAttribute('aria-label','Decrease');
    var num=el('span',null,it.quantity);
    var inc=el('button','cart-q','+'); inc.type='button'; inc.setAttribute('data-line',i+1); inc.setAttribute('data-q',it.quantity+1); inc.setAttribute('aria-label','Increase');
    var rem=el('button','cart-remove','Remove'); rem.type='button'; rem.setAttribute('data-line',i+1); rem.setAttribute('data-q',0); rem.setAttribute('aria-label','Remove');
    qty.appendChild(dec); qty.appendChild(num); qty.appendChild(inc); qty.appendChild(rem);
    info.appendChild(qty); line.appendChild(info);
    line.appendChild(el('div','cart-line__price', money(it.final_line_price)));
    return line;
  }
  function render(cart){
    setCount(cart.item_count);
    if(itemsEl){ Array.prototype.forEach.call(itemsEl.querySelectorAll('.cart-line'),function(n){n.remove();}); }
    if(cart.item_count===0){ if(emptyEl)emptyEl.style.display=''; if(totalEl)totalEl.style.display='none'; return; }
    if(emptyEl)emptyEl.style.display='none'; if(totalEl)totalEl.style.display='';
    cart.items.forEach(function(it,i){ if(itemsEl)itemsEl.appendChild(buildLine(it,i)); });
    if(subEl)subEl.textContent=money(cart.items_subtotal_price);
    if(grandEl)grandEl.textContent=money(cart.total_price);
    var hasPostal=!!getPostal(), thr=postalThreshold(), unlocked=hasPostal&&cart.total_price>=thr;
    var shipEl=document.getElementById('cart-shipping'), lblEl=document.getElementById('csp-label'), trackEl=document.getElementById('csp-track');
    if(shipEl) shipEl.textContent = unlocked ? 'Free' : 'Calculated at checkout';
    if(shipProg&&fillEl){
      shipProg.style.display='';
      if(lblEl) lblEl.style.display = hasPostal ? '' : 'none';
      if(trackEl) trackEl.style.display = hasPostal ? '' : 'none';
      if(hasPostal){
        fillEl.style.width=Math.min(100,(cart.total_price/thr)*100)+'%';
        if(lblEl) lblEl.textContent = unlocked ? 'Free shipping unlocked!' : ('Add '+money(thr-cart.total_price)+' more for free shipping');
      }
    }
  }
  function getCart(cb){ fetch((SHOP.routes&&SHOP.routes.cart)||'/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();}).then(function(c){ render(c); if(cb)cb(c); }).catch(function(){}); }
  document.addEventListener('submit',function(e){
    var form=e.target; if(!form||!form.matches)return;
    if(form.matches('.hs-product__form')||form.matches('.hs-pcard__form')){
      e.preventDefault();
      var btn=form.querySelector('[name="add"]')||form.querySelector('button[type="submit"]');
      if(btn)btn.setAttribute('disabled','');
      fetch((SHOP.routes&&SHOP.routes.cartAdd)||'/cart/add.js',{method:'POST',headers:{'Accept':'application/json'},body:new FormData(form)})
        .then(function(r){return r.json();})
        .then(function(){ getCart(function(){ openCart(); showToast('Added to bag'); }); })
        .catch(function(){})
        ['finally'](function(){ if(btn)btn.removeAttribute('disabled'); });
    }
  });
  if(itemsEl) itemsEl.addEventListener('click',function(e){
    var b=e.target.closest('.cart-q, .cart-remove'); if(!b)return;
    fetch((SHOP.routes&&SHOP.routes.cartChange)||'/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({line:parseInt(b.getAttribute('data-line'),10),quantity:parseInt(b.getAttribute('data-q'),10)})})
      .then(function(r){return r.json();}).then(render).catch(function(){});
  });
  if(toggle)toggle.addEventListener('click',function(e){ e.preventDefault(); getCart(); openCart(); });
  if(closeBtn)closeBtn.addEventListener('click',closeCart);
  if(overlay)overlay.addEventListener('click',closeCart);
  document.addEventListener('keydown',function(e){ if(e.key==='Escape'||e.keyCode===27) closeCart(); });
  var checkoutBtn=document.querySelector('.checkout-btn'); if(checkoutBtn)checkoutBtn.addEventListener('click',function(){ window.location.href='/checkout'; });
  getCart();
})();

/* --- footer newsletter + CTA band ---
   Submission is handled by snippets/hubspot-signup.liquid (routes the email into the HubSpot list)
   and the CTA-band section's own inline script. The old demo handler was removed: it reset the form
   on submit, wiping the email before the HubSpot handler could read it. --- */

/* ===== Ambient page-background blob: mouse-follow + breathing + per-section colour shift ===== */
(function(){
  var orb = document.getElementById('blob-orb');
  var orb2 = document.getElementById('blob-orb-2');
  if(!orb) return;
  var root = document.documentElement;
  var bx=0.5, by=0.5, tx=0.5, ty=0.5;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.addEventListener('mousemove', function(e){ tx=e.clientX/window.innerWidth; ty=e.clientY/window.innerHeight; }, {passive:true});
  function frame(){
    bx += (tx-bx)*0.06; by += (ty-by)*0.06;
    var mx=(bx-0.5)*400, my=(by-0.5)*400;
    var t=Date.now()*0.001;
    var wx=Math.sin(t*0.4)*30, wy=Math.cos(t*0.3)*25, sc=1+Math.sin(t*0.5)*0.08;
    orb.style.transform='translate(calc(-50% + '+(mx+wx)+'px), calc(-50% + '+(my+wy)+'px)) scale('+sc+')';
    if(orb2){ orb2.style.transform='translate('+((bx-0.5)*-160)+'px, '+((by-0.5)*-160)+'px)'; }
    requestAnimationFrame(frame);
  }
  if(!reduce) requestAnimationFrame(frame);
  function setColors(c1,c2){ root.style.setProperty('--blob-color-1', c1); root.style.setProperty('--blob-color-2', c2||c1); }
  var obs = new IntersectionObserver(function(es){
    es.forEach(function(e){ if(e.isIntersecting){ var c=(e.target.getAttribute('data-blob-color')||'').split(','); if(c[0]){ setColors(c[0].trim(), (c[1]||'').trim()); } } });
  }, {threshold:0.35});
  document.querySelectorAll('[data-blob-color]').forEach(function(el){ obs.observe(el); });
})();
